import { HOST } from "common-import/constants";
import { observable, autorun } from "mobx";
import { Request, MobXHelper } from "common-import/helpers";
const { makePersit } = MobXHelper;
import api from "./Contact.API";

const PERSIST_STORE_ITEM = {
  USER_DATA: "USER_STORE_USER_DATA"
}

class Store {
  constructor() {

  }

  @observable currentContactList = [];

  getContactList = async (companyTaxCode) => {
    const res = await api.list({ companyTaxCode });
    const json = await res.json();
    console.log(json);
    return json;
  }

  createContact = async data => {
    const res = await api.create(data);
    const json = await res.json();
    console.log(json);
    return json;
  }
  
}

export default new Store();


// WEBPACK FOOTER //
// ./src/services/contact/Contact.Store.js